<div class="paycheck-details-container">
  <div class="paycheck-title p-3">
    <mwp-text-translate text="Recent Paycheck Details" jsonKey="recentPaycheckDetails" />
  </div>

  <div class="paycheck-doughnut">
    @if (dashboardPayCheckModel) {
      <div class="devx-doughnut-chart">
        <div class="doughnut-legend">
          <dx-pie-chart id="pie" type="doughnut" [customizePoint]="customizePoint" [dataSource]="paycheckDetails" [innerRadius]="0.7">
            <dxi-series argumentField="detail">
              <dxo-label [visible]="false" [format]="{ type: 'currency', precision: 2, currency: 'USD' }">
                <dxo-connector [visible]="true"></dxo-connector>
              </dxo-label>
            </dxi-series>
            <dxo-export [enabled]="false"></dxo-export>
            <dxo-legend [visible]="false" [margin]="0" horizontalAlignment="left" verticalAlignment="bottom"></dxo-legend>
            <dxo-tooltip [enabled]="false" [customizeTooltip]="customizeTooltip" [format]="{ type: 'currency', precision: 2, currency: 'USD' }">
            </dxo-tooltip>
          </dx-pie-chart>
          <div class="doughnut-legend-details p-3">
            <div class="detail"><mwp-text-translate class=doughnut-deductions text="Deductions:" jsonKey="deductions" />{{dashboardPayCheckModel.deductions | currency}} </div>
            <div class="detail">
              <mwp-text-translate class="doughnut-taxes" text="Taxes:" jsonKey="taxes" />{{dashboardPayCheckModel.taxes | currency}}
            </div>
            <hr />
            <div class="detail doughnut-net-pay">
              <mwp-text-translate text="Net Pay:" jsonKey="netPay" />{{dashboardPayCheckModel.netPay | currency}}
            </div>
          </div>
        </div>
      </div>
    }
  </div>
  <div class="p-3">
    <button class="mwp-button-green w-100" (click)="goToPayHistory()">
      <mwp-text-translate text="Paycheck Details" jsonKey="paycheckDetails" />
    </button>
  </div>
</div>